import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { updateEcommerceID } from "../api/updateEcommApi";
import Cookies from "js-cookie";
import { Bounce, toast } from "react-toastify";
// Async thunk to call the update API
export const updateEcommIdThunk = createAsyncThunk(
  "ecommerce/updateEcommId",
  async ({ ecomm_order_id, reservation_id }, { rejectWithValue }) => {
    try {
      const sessionExpired = (msg) => {
        toast(msg, {
          style: {
            background: "#f87171",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "2rem",
            padding: "1rem",
            width: "20dvh",
          },
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
          transition: Bounce,
          closeButton: ({ closeToast }) => (
            <button
              className="text-white text-4xl leading-none rounded-full p-2"
              onClick={closeToast}
            >
              ×
            </button>
          ),
        });
      };

      const response = await updateEcommerceID(ecomm_order_id, reservation_id);

      if (
        !response?.data?.status &&
        response?.data?.data == "user not found, check your token"
      ) {
        sessionExpired("Session has expired");

        setTimeout(() => {
          window.location.href = "/logout";
        }, 3000);
        return Promise.reject(
          new Error("Branch ID is missing. Redirecting to logout.")
        );
      }
      return response.data; // Assuming the API returns relevant data
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const updateEcommIdSlice = createSlice({
  name: "updateEcommId",
  initialState: {
    isLoading: false,
    isSuccess: false,
    error: null,
  },
  reducers: {
    resetState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateEcommIdThunk.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.error = null;
      })
      .addCase(updateEcommIdThunk.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.error = null;
      })
      .addCase(updateEcommIdThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { resetState } = updateEcommIdSlice.actions;
export const updateEcommIdReducer = updateEcommIdSlice.reducer;
